export default __webpack_public_path__ + "static/media/calender-icon.f172c4f8.svg";